// MACHINERY V2 (Stroje) — Filter pattern B, row 1 (M2.16a).
//
// >>> PATTERN B IS THE CHOSEN ONE, AND A AND C ARE NOT TO BE BUILT. <<<
// mobile/README.md §"THE DECISION": search field + Filtre(n) + (row 2) active
// chips. Rendered truth: mobile/screenshots/01-filter-b-chosen.png (closed) and
// 02-filter-sheet-open.png (open). Patterns A and C exist in the package only to
// document the rejection — screenshots 03- and 04- are NOT a backlog.
//
// Reference impl: mobile/machinery-mobile.jsx MbFilterB (:75-97). Values taken
// verbatim; the code is not.
//
// >>> THE TWO CONTROLS MOVED TO filterBarAtoms.tsx AT M2.16c. <<< This file is
// now the FLEET'S ARRANGEMENT of them — one row, search then Filtre — and the
// katalog arranges the same two pieces differently (search on its own row,
// Filtre in the category chip row; mobile/screenshots/16-katalog-list.png).
// Nothing about the fleet's rendering changed in that move: same elements, same
// styles, same order. The count badge is still hidden at zero, and it is hidden
// there, once, for both consumers.
//
// SEARCH IS THE PAGE'S OWN, not a second one: the value and both callbacks come
// straight from useFleetSearch via the shell, so the 400 ms debounce, the
// stale-merge fix and the unmount cleanup (useFleetSearch.ts:14-20) all still
// apply, and there is ONE search state across desktop and mobile.
//
// Row 2 lives in ActiveFilterChips.tsx — a separate component because it renders
// only when filters are set, and because its chips are surface-specific while
// this row is not.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

import { FiltreButton, SearchFieldB } from "./filterBarAtoms";

export interface FilterBarBProps {
  search: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: () => void;
  /** Number of active filter GROUPS — the badge number, and what the design's
   *  "2" counts against its two chips. Zero hides the badge. */
  activeCount: number;
  onOpenFilters: () => void;
}

const FilterBarB: React.FC<FilterBarBProps> = ({
  search,
  onSearchChange,
  onSearchSubmit,
  activeCount,
  onOpenFilters,
}) => (
  <div
    style={{
      // The design's `padding: "0 14px 10px"`, with the bottom edge handed to
      // row 2 when row 2 exists — the chip row brings its own 9px of vertical
      // padding (its pills are 26px inside 44px touch targets), so keeping both
      // would double the gap the board draws at 8px.
      padding: `0 14px ${activeCount > 0 ? 0 : 10}px`,
      flexShrink: 0,
    }}
  >
    <div style={{ display: "flex", gap: 8 }}>
      <SearchFieldB
        value={search}
        onChange={onSearchChange}
        onSubmit={onSearchSubmit}
      />
      <FiltreButton activeCount={activeCount} onClick={onOpenFilters} />
    </div>
  </div>
);

export default FilterBarB;
